import React from 'react';

const Table = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200 shadow-sm">
      <table
        className={`min-w-full divide-y divide-slate-200 ${className}`}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

const TableHeader = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <thead className={`bg-slate-50/80 border-b border-slate-200 ${className}`} {...props}>
      {children}
    </thead>
  );
};

const TableBody = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <tbody className={`bg-white divide-y divide-slate-100 ${className}`} {...props}>
      {children}
    </tbody>
  );
};

const TableRow = ({
  children,
  className = '',
  clickable = false,
  ...props
}) => {
  const baseClasses = clickable ? 'hover:bg-slate-50 cursor-pointer transition-colors duration-150' : 'hover:bg-slate-50/50 transition-colors duration-150';

  return (
    <tr className={`${baseClasses} ${className}`} {...props}>
      {children}
    </tr>
  );
};

const TableCell = ({
  children,
  className = '',
  header = false,
  ...props
}) => {
  const Component = header ? 'th' : 'td';
  const baseClasses = header
    ? 'px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider'
    : 'px-6 py-4 whitespace-nowrap text-sm text-slate-700';

  return (
    <Component className={`${baseClasses} ${className}`} {...props}>
      {children}
    </Component>
  );
};

export default Table;
export { TableHeader, TableBody, TableRow, TableCell };